import React from 'react';
import styled from 'styled-components';
// CSS
import './SignUp.css';

import CreateAccount from './components/CreateAccount';
import SignupSlider from './components/Slider';
import assets from 'assets';

function SignUp() {
  return (
    <MainContainer>
      <div className='main-logo'>
        <img src={assets.logoWithText} alt='' />
      </div>
      <div className='left-side'>
        <div className='container'>
          <SignupSlider />
        </div>
      </div>
      <Container className='mobile'>
        <FormContainer>
          <CreateAccount />
        </FormContainer>
      </Container>

    </MainContainer>
  );
}

export default SignUp;

const MainContainer = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  & .main-logo{
    display: none;
  }

  & .left-side {
      padding: 30px 0px 30px 30px;
      width: 60%;
      min-height: 100vh;

    & .container {
     background-color: var(--darkgrey);
     display: flex;
     border-radius: 20px;
     justify-content: center;
     width: 100%;
     height: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
     
    }
  }

  @media only screen and (max-device-width: 800px){
    display: flex;
    flex-direction: column;
    gap: 0px;
    width: fit-content;
    .left-side{
      width: max-content;
      padding: 30px;
    }

    & .logo{
      display: none;
    }
  
    & .main-logo{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
    }

    & .input-box {
      margin-top: 0px;
    }

    & .checkbox-list{
      padding: 10px;
    }

    & .mobile{
      display: flex;
      width: 100%;
    }
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 40%;
  .input-box {
    margin: 0 10px;
    & .input-label {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: var(--primary);
      opacity: 0.5;
      margin-bottom: 0;
      padding-bottom: 5px;
      float: left;
    }
  }

  .input-box .confirm-details {
    background: var(--red);
    border-radius: 7px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: var(--primary);
    opacity: 1;
    border: none;
    height: 45px;
    width: 100%;
    margin-top: 13px;
    margin-bottom: 20px;
  }

  /*  */
  @media only screen and (max-width: 520px) {
    margin: 0 10px;
  }
`;

const FormContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
